import { CONTACT_INFO } from "../config/constants";

export default function WhatsAppButton() {
  return (
    <div
      className="fixed bottom-6 left-6 z-40"
      style={{ pointerEvents: "none" }}
    >
      <div className="relative group" style={{ pointerEvents: "auto" }}>
        {/* Pulse ring animation */}
        <span
          className="absolute inset-0 rounded-full animate-ping"
          style={{
            background: "rgba(37, 211, 102, 0.35)",
            animationDuration: "1.8s",
          }}
        />

        {/* WhatsApp Button */}
        <a
          href={CONTACT_INFO.whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with us on WhatsApp"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #25d366, #128c7e)",
            boxShadow:
              "0 8px 30px rgba(37, 211, 102, 0.5), 0 4px 12px rgba(0,0,0,0.3)",
            transition: "transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease",
            position: "relative",
            zIndex: 1,
            pointerEvents: "auto",
            touchAction: "manipulation",
            textDecoration: "none",
            flexShrink: 0,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.15)";
            e.currentTarget.style.boxShadow =
              "0 12px 40px rgba(37, 211, 102, 0.7), 0 6px 20px rgba(0,0,0,0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow =
              "0 8px 30px rgba(37, 211, 102, 0.5), 0 4px 12px rgba(0,0,0,0.3)";
          }}
        >
          {/* WhatsApp SVG Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="32"
            height="32"
            fill="white"
            aria-hidden="true"
          >
            <path d="M16.004 2C8.28 2 2 8.28 2 16.004c0 2.47.65 4.88 1.88 7.01L2 30l7.18-1.85A13.94 13.94 0 0 0 16.004 30C23.72 30 30 23.72 30 16.004 30 8.28 23.72 2 16.004 2zm0 25.5a11.45 11.45 0 0 1-5.83-1.6l-.42-.25-4.26 1.1 1.12-4.14-.27-.44A11.46 11.46 0 0 1 4.5 16.004C4.5 9.66 9.66 4.5 16.004 4.5 22.34 4.5 27.5 9.66 27.5 16.004S22.34 27.5 16.004 27.5zm6.29-8.56c-.34-.17-2.02-1-2.33-1.11-.31-.11-.54-.17-.76.17-.23.34-.88 1.11-1.08 1.34-.2.23-.4.26-.74.09-.34-.17-1.44-.53-2.74-1.69-1.01-.9-1.7-2.01-1.9-2.35-.2-.34-.02-.52.15-.69.15-.15.34-.4.51-.6.17-.2.23-.34.34-.57.11-.23.06-.43-.03-.6-.09-.17-.76-1.84-1.04-2.52-.27-.66-.55-.57-.76-.58l-.65-.01a1.25 1.25 0 0 0-.91.43c-.31.34-1.2 1.17-1.2 2.85 0 1.68 1.23 3.31 1.4 3.54.17.23 2.41 3.68 5.84 5.16.82.35 1.46.56 1.96.72.82.26 1.57.22 2.16.13.66-.1 2.02-.83 2.31-1.62.28-.8.28-1.48.2-1.62-.09-.14-.31-.23-.65-.4z" />
          </svg>
        </a>

        {/* Tooltip */}
        <div
          style={{
            position: "absolute",
            bottom: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            marginBottom: "10px",
            padding: "6px 14px",
            background: "linear-gradient(135deg, #25d366, #128c7e)",
            color: "#fff",
            fontSize: "13px",
            fontWeight: "700",
            borderRadius: "8px",
            whiteSpace: "nowrap",
            opacity: 0,
            pointerEvents: "none",
            transition: "opacity 0.3s ease",
            boxShadow: "0 4px 12px rgba(37,211,102,0.4)",
          }}
          className="group-hover:opacity-100"
        >
          Chat on WhatsApp
          {/* Tooltip arrow */}
          <div
            style={{
              position: "absolute",
              bottom: "-5px",
              left: "50%",
              transform: "translateX(-50%) rotate(45deg)",
              width: "10px",
              height: "10px",
              background: "#128c7e",
            }}
          />
        </div>
      </div>
    </div>
  );
}
